import React, { Component } from "react";
import ComponentTemplate from "../../../Utilities/TemplateWrappers/ComponentTemplate";

import {
    Typography,
    Select,
    MenuItem,
    List,
    ListItem,
    ListItemText,
} from "@material-ui/core";
import _ from "lodash";
import { getVehicles, getAreas, getDepartments } from "./actions";
import { connect } from "react-redux";

class JobPackVehicleList extends Component {
    constructor(props) {
        super(props);
        props.getVehicles();
        props.getAreas();
        props.getDepartments();
        this.state = { profile: props.profile, edit: props.edit };
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.profile !== this.props.profile) {
            this.setState({ profile: this.props.profile });
        }
    }
    renderDropdown = (label, key, opts) => {
        const { profile } = this.state;
        if (this.state.edit) {
            return (
                <div
                    style={{
                        display: "flex",
                        marginBottom: 30,
                        marginLeft: "19px",
                    }}
                >
                    <Typography style={{ width: 200 }} variant="h6">
                        <b>{label}:</b>
                    </Typography>
                    <Select
                        style={{ width: "50%" }}
                        value={
                            profile[key]
                                ? profile[key].map((e) => {
                                      return _.get(e, "machine_reg") || null;
                                  })
                                : !profile[key]
                                ? []
                                : profile[key]
                        }
                        multiple={true}
                        onChange={(event) => {
                            let newArray = _.flattenDeep(
                                _.compact(
                                    event.target.value.map((e) => {
                                        return _.compact(
                                            opts.map((f) => {
                                                if (e === f.machine_reg) {
                                                    return f;
                                                } else return false;
                                            })
                                        );
                                    })
                                )
                            );

                            this.props.callback(key, newArray);
                        }}
                    >
                        {opts.map((e) => {
                            return (
                                <MenuItem
                                    key={e.machine_reg}
                                    value={e.machine_reg}
                                >
                                    {e.machine_desc + " - " + e.machine_reg}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </div>
            );
        } else {
            return null;
        }
    };
    render() {
        const { vehicles, profile } = this.props;

        return (
            <ComponentTemplate
                isCollapsed={false}
                isCollapsable={true}
                label="Assigned Vehicles (required)"
            >
                {vehicles && (
                    <>
                        {this.renderDropdown(
                            "Assigned Vehicles",
                            "job_vehicles",
                            vehicles
                        )}
                    </>
                )}
                <List dense={false}>
                    {profile.job_vehicles &&
                        profile.job_vehicles.map((e) => {
                            return (
                                <ListItem key={e}>
                                    <ListItemText
                                        primary={e.machine_desc}
                                        secondary={e.machine_reg}
                                    />
                                </ListItem>
                            );
                        })}
                </List>
            </ComponentTemplate>
        );
    }
}
export default connect(
    (store, props) => {
        const { selectors } = props;
        const {
            selectVehicleInfo,
            selectDept,
            selectAreas,
            selectAllDepartments,
            selectAllAreas,
        } = selectors;
        return {
            vehicles: selectVehicleInfo(store),
            profileDepts: selectDept(store),
            profileAreas: selectAreas(store),
            allDepartments: selectAllDepartments(store),
            allAreas: selectAllAreas(store),
        };
    },
    { getVehicles, getAreas, getDepartments }
)(JobPackVehicleList);
